<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<h2 class="back-btn">安全设置</h2>
	</div>
	<div class="ld-panel-main">
		<ul class="safety-info">
			<li><em>会员ID：</em>{{userInfo.username}}</li>
			<li><em>注册日期：</em>{{userInfo.regtime}}</li>
			<li>
				<em>安全级别：</em>
				<div class="progress-bar">
					<p :class="'progress-bar'+userInfo.starLevel" :style="{'width': userInfo.starPer+'%'}"></p>
				</div>
				<em :class="'progress'+userInfo.starLevel">{{starLevel}}</em>
				<p style="display: inline;" v-if="userInfo.starPer < 75"><el-text type="danger">建议您启动全部安全设置，以保障账户及资金安全。</el-text></p>
			</li>
		</ul>
		<ul class="safety-settings">
			<li>
				<span class="status yes"></span>
				<span class="name">登录密码</span>
				<span class="info">安全性高的密码可以使账户更安全；互联网账号存在被盗风险，建议您定期更换密码</span>
				<div class="btn"><router-link to="/account/pwd">修改</router-link></div>
			</li>
			<li>
				<span class="status" :class="{'yes':userInfo.checkMobile==1}"></span>
				<span class="name">手机绑定</span>
				<span class="info"><span v-if="userInfo.mobileEncrypt">您的手机：<el-text type="primary">{{userInfo.mobileEncrypt}}</el-text>。</span> 绑定认证后可用于手机找回密码、接收手机动态验证码等，保障您的账户安全。</span>
				<div class="btn"><router-link to="/account/mobile" :class="{'link':userInfo.checkMobile !=1}">{{userInfo.checkMobile==1 ? '修改':'立即启用'}}</router-link></div>
			</li>
			<li>
				<span class="status" :class="{'yes':userInfo.checkEmail==1}"></span>
				<span class="name">邮箱绑定</span>
				<span class="info">您的邮箱：<span v-if="userInfo.emailEncrypt"><el-text type="primary">{{userInfo.emailEncrypt}}</el-text>。</span> 绑定邮箱后，是您找回登录密码的方式之一。</span>
				<div class="btn">
					<router-link to="/account/email" :class="{'link':userInfo.checkEmail !=1}">{{userInfo.checkEmail==1 ? '修改':'立即启用'}}</router-link>
				</div>
			</li>
			<li>
				<span class="status" :class="{'yes':userInfo.checkWechat}"></span>
				<span class="name">微信绑定</span>
				<span class="info">
					<el-text type="primary" v-if="userInfo.checkWechat">已绑定微信</el-text>
					<span v-else>可实现微信二维码登录，接收产品变动提示。现在绑定立即领取 [超值礼包]</span>
				</span>
				<div class="btn">
					<span v-if="userInfo.checkWechat">
						<router-link to="/account/weixin" style="margin-right: 12px;">修改</router-link>
						<router-link to="/account/weixin?action=weixinUnbind">解绑</router-link>
					</span>
					<router-link to="/account/weixin" v-else class="link">立即绑定</router-link>
				</div>
			</li>
			<li>
				<span class="status" :class="{'yes':userInfo.checkQuestion}"></span>
				<span class="name">密保问题</span>
				<span class="info">设置密保问题可以进一步提升您的账户安全性。是您找回登录密码的方式之一。</span>
				<div class="btn"><router-link to="/account/protection" :class="{'link':userInfo.checkQuestion == false}">{{userInfo.checkQuestion ? '修改':'立即启用'}}</router-link></div>
			</li>
			<li>
				<span class="status" :class="{'yes':userInfo.authStatus==1}"></span>
				<span class="name">实名认证</span>
				<span class="info">
					<span v-if="userInfo.authStatus == 1">
						您的实名认证类型：
						<el-text type="success" v-if="userInfo.authType == 2">企业认证</el-text>
						<el-text type="success" v-else>个人认证</el-text>
					</span>
					<span v-else>实名认证可享受更多会员权益</span>					
				</span>
				<div class="btn"><router-link to="/verify" class="link">立即认证</router-link></div>
			</li>
			<li>
				<span class="status del"></span>
				<span class="name">账号注销</span>
				<span class="info">注销账号 如果您不再使用此账号，可以将其注销。账号成功注销后，其下所有服务、数据及隐私信息将会被删除并将无法恢复。</span>
				<div class="btn"><router-link to="/account/unsubscribe" class="link">账号注销</router-link></div>
			</li>
			<li>
				<span class="status appeal"></span>
				<span class="name">账号申诉</span>
				<span class="info">如您已更换手机号码且已遗忘密保问题，可以通过账号申诉重新绑定您的新手机号码。</span>
				<div class="btn"><router-link to="/appeal" class="link">账号申诉</router-link></div>
			</li>
		</ul>
	</div>
</template>

<script setup>
	import { ref,reactive,inject,onMounted} from 'vue';
	import sideNav from '../../components/sideNav.vue';
	import Cookies from 'js-cookie';
	import { getUserInfo } from '@/api/account';
	import { ElMessage } from 'element-plus';

	const pageTitle = 'account';
	const domain = inject('domain');
	const userInfo = ref('');
	const regtime = ref('');
	const starLevel = ref('');
	
	const getUserInfoF = () => {
		getUserInfo().then((res) => {
			if(res.code === 200){
				userInfo.value = res.data;
				Cookies.set('LDUSERNAME',res.data.username);
				Cookies.set('LDMOBILE',res.data.mobileEncrypt);
				const level = res.data.starLevel;
				switch(level)
				{
					case 1:
						starLevel.value = '低'
					break;
					case 2:
						starLevel.value = '中'
					break;
					case 3:
						starLevel.value = '高'
					break;
					default:
						starLevel.value = ' '
				}
			}
		})
	};
	
	onMounted(() => {
		getUserInfoF()
	})
	
</script>

<style lang="scss" scoped>
	.code{
		overflow: hidden;
		.el-form-item{
			width: 66%;
			float: left;
			.el-input{width: 100%; margin-right: 20px;}
		}
	}
	.progress-bar{ 
		height:20px; 
		width:260px; 
		position:relative; 
		background:#fff; 
		border-radius:4px; 
		display:inline-block;
		vertical-align:top;
		margin-right: 15px;
		p{ position:absolute; left:0; top:0; bottom:0;border-radius:4px; }
		.progress-bar3{ background:#14cc39;}
		.progress-bar2{ background:#ffa200;}
		.progress-bar1{ background:red;}
	}
	.progress3{ color:#14cc39 !important;}
	.progress2{ color:#ffa200 !important;}
	.progress1{ color:red !important;}
	.safety-info{
		border: 1px solid #eee;
		padding-left: 125px;
		padding-top: 20px;
		min-height: 128px;
		background: url(../../assets/images/avatar.png) no-repeat 24px center #f7f9fa;
		li{
			margin: 8px;
			font-size: 12px;
			em{
				display: inline-block;
				vertical-align: top;
				width: 80px;
				color: #a0a2a3;
			}
		}
	}
	.safety-settings{
		padding: 20px;
		overflow: hidden;
		li{
			height: 80px;
			line-height: 79px;
			font-size: 12px;
			border-bottom: 1px dashed #e6e6e6;
			white-space: nowrap;
			overflow: hidden;
			.status{ display: inline-block;vertical-align: middle; height: 24px;width: 24px;background: url(../../assets/images/account_status_warn.png) no-repeat center;}
			.yes{background: url(../../assets/images/account_status_success.png) no-repeat center;}
			.appeal{background: url(../../assets/images/account_status_appeal.png) no-repeat center;}
			.del{background: url(../../assets/images/account_status_del.png) no-repeat center; background-size: 23px;}
			.name{width: 80px; margin:0 16px;}
			.info{color: #999; font-size: 12px;}
			.btn{
				min-width: 88px;
				text-align: center;
				float: right;
				font-size: 12px;
				.link{border: 1px solid #dcdfe6; height: 32px; line-height: 32px; color: #606266; display: inline-block; padding: 0 15px; border-radius: 4px;font-size: 12px;}
				.link:hover{border-color: #015BFE;color: #015BFE;}
			}
		}
	}
</style>